import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { AuthService } from '@services/security';
import { environment } from '@environments/environment';

@Injectable({
    providedIn: 'root',
})
export class ManageProfilesUsersGuard implements CanActivate {
    constructor(private authService: AuthService) {}
    canActivate(): boolean {
        if (
            !this.authService.isAdmin &&
            this.authService.isProfileWithPermission()
        ) {
            return true;
        }

        window.location.href = `${environment.psp}/dashboard`;

        return false;
    }
}
